module.exports = __webpack_public_path__ + "img/partner-2.7416f640.png";